module.exports = __webpack_public_path__ + "img/hero.bkp.386754d9.jpg";